// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"2b59cff6","585":"87a3b63e","626":"1d5d4f29","656":"2b59cff6","927":"2b59cff6"}[chunkId] + ".chunk.css";
};